import { MultiSelect } from 'legacy/lut/library/multiSelect'
import { useCallback, useMemo } from 'react'

import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { IQBRDocumentsListItem } from 'partner360/models/qbr/IQBRDocumentsListItem'

import styles from '../QBRDocumentsFilterArea.module.scss'

interface IQBRGeoMultiselectProps {
  qbrDocumentsData: IQBRDocumentsListItem[]
  geoValue: string[]
  onChangeGeoValue: (value: string[]) => void
}

export const QBRGeoFilter = ({
  qbrDocumentsData,
  geoValue,
  onChangeGeoValue,
}: IQBRGeoMultiselectProps) => {
  const geoArray = qbrDocumentsData.map((values) => {
    return values.Market || ''
  })

  const parsedValues = useMemo(() => {
    return [...new Set(geoArray.flatMap((el) => el.split(';')))]
  }, [geoArray])

  const crud = useMemo(() => {
    return new Crud({
      fetcher: new Static(parsedValues.map((el) => ({ value: el }))),
      keyField: 'value',
      defaultSort: { field: 'value', dir: 'asc' },
      defaultPaging: { page: 0, pageSize: parsedValues.length },
    })
  }, [parsedValues])

  const onGeoMarketChange = useCallback(
    (value: string[]) => {
      onChangeGeoValue(value)
    },
    [onChangeGeoValue]
  )

  return (
    <div className={styles.filter}>
      <MultiSelect
        value={geoValue}
        source={crud}
        label="GeoMarket"
        caption={'value'}
        onChange={onGeoMarketChange}
      />
    </div>
  )
}
